










































































import _ from 'lodash'
import { Vue, Component } from 'vue-property-decorator'
import { Action, Mutation, State } from 'vuex-class'
import { RootState } from '@/store/types'
import { StencilSet, Stencil } from '@/store/editor/types'
import { DropdownOption } from '@/components/common/VDropdown.vue'
import { FETCH_UPDATES, VAULT_TREE_CLOSE_ALL } from '@/store/entries/constants'
import { EDITOR_CLEAR, EDITOR_SET_SCHEMA } from '@/store/editor/constants'

@Component({ name: 'side-panel-footer' })
export default class SidePanelFoor extends Vue {
    refreshing: boolean = false

    /**
     * Entry schema stencils
     */
    @State((state: RootState) => state.editor.stencils)
    stencils!: StencilSet

    /**
     * Return to root (home) directory
     */
    @Action(VAULT_TREE_CLOSE_ALL)
    closeAllVaults!: () => void

    @Action(FETCH_UPDATES)
    fetchUpdates!: (force?: boolean) => Promise<void>

    /**
     * Clear the editor
     */
    @Mutation(EDITOR_CLEAR)
    clearEditor!: () => void

    /**
     * Set the editor schema
     */
    @Mutation(EDITOR_SET_SCHEMA)
    setSchema!: (value: string) => void

    async refreshVaults(): Promise<void> {
        this.refreshing = true
        await this.fetchUpdates(true)
        setTimeout(() => {
            this.refreshing = false
        }, 2000)
    }

    /**
     * Schema options for the dropdown
     */
    get schemas(): DropdownOption[] {
        return _.map(this.stencils, (value: Stencil, key: string) => ({
            name: value.title,
            value: key,
            icon: value.defaultIcon
        }))
    }

    newEntry(value: string): void {
        this.clearEditor()
        this.setSchema(value)
    }
}
